import * as swcHelpers from '@swc/helpers';
import { fromListStoreGroupsQueryToStoreGroup } from './adapters.js';
import { GET_LIST_STORE_GROUPS } from './queries.js';

function getListStoreGroups(apolloClient, locale) {
    return _getListStoreGroups.apply(this, arguments);
}
function _getListStoreGroups() {
    _getListStoreGroups = swcHelpers.asyncToGenerator(function*(apolloClient, locale) {
        try {
            const { data , error  } = yield apolloClient.query(swcHelpers.objectSpread({
                query: GET_LIST_STORE_GROUPS
            }, locale ? {
                context: {
                    forwardHeaders: {
                        'Accept-Language': locale
                    }
                }
            } : {}));
            if (error) {
                console.error(error);
                throw new Error(error.message);
            }
            return fromListStoreGroupsQueryToStoreGroup(data === null || data === void 0 ? void 0 : data.listStoreGroups);
        } catch (e) {
            console.error(`Failed to query listStoreGroups: ${e}`);
            return {};
        }
    });
    return _getListStoreGroups.apply(this, arguments);
}

export { getListStoreGroups };
//# sourceMappingURL=data.js.map
